import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  PriceListDataService,
  PriceListModel,
} from '../../services/price-list-data.service';

@Component({
  selector: 'app-price-list-add-dialog',
  templateUrl: './price-list-add-dialog.component.html',
  styleUrls: ['./price-list-add-dialog.component.css'],
})
export class PriceListAddDialogComponent implements OnInit {
  adding = false;
  originalFormValues: any;

  itemData: PriceListModel = {
    productCode: '',
    barcode: '',
    productName: '',
    unit: '',
    retailPrice: null as any,
  };

  itemDataEdit: PriceListModel = {
    productCode: '',
    barcode: '',
    productName: '',
    unit: '',
    retailPrice: null as any,
  };

  constructor(
    public priceListDataService: PriceListDataService,
    public dialogRef: MatDialogRef<PriceListAddDialogComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public importingData: { action: string; data?: PriceListModel }
  ) {}

  ngOnInit(): void {
    if (this.importingData?.data) {
      this.itemDataEdit = { ...this.importingData.data };
      this.originalFormValues = { ...this.itemDataEdit };
    }
  }

  async addNewItemFromDialog() {
    this.adding = true;
    await this.priceListDataService.addItem(this.itemData);
    this.adding = false;
    this.dialogRef.close('res');
  }

  async editItemFromDialog() {
    await this.priceListDataService.editItem(this.itemDataEdit);
    this.dialogRef.close();
  }

  isFormDirty(): boolean {
    return (
      JSON.stringify(this.originalFormValues) !==
      JSON.stringify(this.itemDataEdit)
    );
  }

  /**
   * A name and a price are mandatory; the code and barcode are both optional
   * because an item can still be matched on its name alone. The price must be a
   * non-negative number — 0 is allowed, since price lists do carry free items.
   */
  private isValid(item: PriceListModel): boolean {
    if (!item.productName?.trim()) return false;
    if (item.retailPrice === null || (item.retailPrice as any) === '' || item.retailPrice === undefined) {
      return false;
    }
    const price = Number(item.retailPrice);
    return !isNaN(price) && price >= 0;
  }

  isFormValid(): boolean {
    return this.importingData?.action === 'Add'
      ? this.isValid(this.itemData)
      : this.isValid(this.itemDataEdit);
  }
}
